// src/ai.js
import axios from "axios";
import personality from "./personality.js";

// Dinamik bilgi kaynakları
import friends from "./knowledge/friends.js";
import venues from "./knowledge/venues.js";
import djs from "./knowledge/djs.js";
import { getTarsSystemPrompt } from "./tarsData.js";

// Backend sabit
const API_BASE = "";

// Küçük yardımcılar
const lower = (v) => (v || "").toLowerCase();
const joiner = (v, sep = ", ") =>
  Array.isArray(v) ? v.join(sep) : (v || "");

// Çöp belirteç temizleyici (bazı modeller <s>, </s>, özel token döndürüyor)
function sanitize(raw) {
  return (raw || "")
    .replace(/^\s*<s>\s*/gi, "")
    .replace(/\s*<\/s>\s*$/gi, "")
    .replace(/<\|im_start\|>|<\|im_end\|>/g, "")
    .trim();
}

// Her cevabı “bro/dostum” ile başlatmayı zorunlu kılan kemer
function withOpening(text) {
  const openings =
    personality?.style_rules?.openings || ["Bro,", "Dostum,", "Dostum benim,"];
  const t = (text || "").trim();
  const head = lower(t.slice(0, 32));
  const already = openings.some((o) => head.startsWith(lower(o)));
  if (already) return t;
  const pick = openings[Math.floor(Math.random() * openings.length)];
  return `${pick} ${t}`;
}

// ---- Dinamik bilgi seçici (soruya göre friends / clubs / djs) ----

function pickFriendsContext(userText, memory) {
  const allText = lower(
    [userText, ...memory.map((m) => m.text || "")]
      .join(" \n ")
  );

  const matches = [];
  let hasAliasHit = false;

  for (const f of friends || []) {
    const aliases = f.aliases || [];
    const hit = aliases.some((a) => allText.includes(lower(a)));
    if (hit) {
      matches.push(f);
      hasAliasHit = true;
    }
  }

  const mentionsFriendsWord = /arkadaş|kanka|dostlar|kankalar|çevrendeki insanlar|arkadaşların/i.test(
    userText || ""
  );

  let used;
  if (hasAliasHit) {
    // Spesifik isimler varsa sadece onları bağlama ekle
    used = matches;
  } else if (mentionsFriendsWord) {
    // Genel soru soruldu, tüm listeyi yüklemek yerine yapay zekaya yönlendirme ver
    return ">>> Sistem Notu: Kullanıcı Aykut'un arkadaşları hakkında genel bir soru sordu. Aykut'un çok geniş bir çevresi (rave tayfası, eski ev arkadaşları, dj'ler vs.) var. Tüm listeyi dökmek yerine, 'Aykut'un çevresi çok geniş sen kimden bahsediyorsun?' tarzında kendi cool üslubunla bir yanıt ver.";
  } else {
    used = [];
  }

  if (!used.length) return "";

  const lines = used.map((f) => {
    const header = `- ${f.displayName || f.id} (${f.relationToAykut || "Aykut'un çevresinden"}):`;
    const oneLine = f.oneLine ? ` ${f.oneLine}` : "";
    const bio = f.bio ? ` ${f.bio}` : "";
    const how = f.howToTalk ? ` Konuşma notu: ${f.howToTalk}` : "";
    return `${header}${oneLine}${bio}${how}`;
  });

  return [
    ">>> KİMLİK TEYİT PROTOKOLÜ DİKKAT!",
    "Kullanıcı bir kişiyi sordu ve veri tabanında aşağıdaki kişi/kişiler bulundu.",
    "KURAL 1: Kullanıcı henüz KİMDEN bahsettiğini TEYİT ETMEDİ. Bu yüzden aşağıdaki bilgileri (ne iş yaptığı, kim olduğu vb.) KULLANICI ONAYLAMADAN ASLA DİREKT VERME.",
    "KURAL 2: Önce kullanıcının kimi kastettiğini anlamak için IG (Instagram) adresini sorarak teyit al.",
    used.length > 1 
      ? "KURAL 3: Veri tabanında bu isimde BİRDEN FAZLA kişi bulundu. Kullanıcıya 'Hangisinden bahsediyorsun?' diyerek her ikisinin/hepsinin IG kullanıcı adlarını veya ayırt edici kısa bir özelliklerini (örneğin 'IG: x olan mı yoksa IG: y olan mı?') sorarak teyit iste."
      : "KURAL 3: Veri tabanında bu isimde 1 kişi bulundu. Kullanıcıya 'IG: [kişinin_ig_adresi]'nden mi bahsediyorsun?' şeklinde sor. (IG adresi aşağıdaki bio'da yazıyor olabilir).",
    "KURAL 4: SADECE KULLANICI 'Evet' DERSE VEYA ONAYLARSA BU BİLGİLERİ VER.",
    "",
    ">>> Bulunan Kişi/Kişiler Hakkında Ek Bağlam:",
    ...lines,
  ].join("\n");
}

function pickVenuesContext(userText, memory) {
  const allText = lower(
    [userText, ...memory.map((m) => m.text || "")]
      .join(" \n ")
  );

  const matches = [];
  let hasAliasHit = false;

  for (const v of venues || []) {
    const aliases = v.aliases || [];
    const hit = aliases.some((a) => allText.includes(lower(a)));
    if (hit) {
      matches.push(v);
      hasAliasHit = true;
    }
  }

  const mentionsVenuesWord = /mekan|mekân|club|klüp|kulüp|gece kulübü|rave|parti|venue/i.test(
    userText || ""
  );

  let used;
  if (hasAliasHit) {
    used = matches;
  } else if (mentionsVenuesWord) {
    // Tüm mekanları yükleme, yönlendirme ver
    return ">>> Sistem Notu: Kullanıcı mekanlar/kulüpler hakkında genel bir soru sordu. Aykut'un İstanbul techno piyasasında gittiği çok fazla mekan var (74 Hall, RX, Vw arana vb). Kullanıcıya 'hangi mekandan bahsediyorsun?' tarzı cool bir yanıt ver.";
  } else {
    used = [];
  }

  if (!used.length) return "";

  const lines = used.map((v) => {
    const header = `- ${v.displayName || v.id} (${v.city || "Şehir bilinmiyor"}):`;
    const oneLine = v.oneLine ? ` ${v.oneLine}` : "";
    const bio = v.bio ? ` ${v.bio}` : "";
    const tags = v.tags?.length ? ` Etiketler: ${v.tags.join(", ")}.` : "";
    return `${header}${oneLine}${bio}${tags}`;
  });

  return [
    ">>> Mekanlar / clublar hakkında ek bağlam:",
    ...lines,
  ].join("\n");
}

function pickDJsContext(userText, memory) {
  const allText = lower(
    [userText, ...memory.map((m) => m.text || "")]
      .join(" \n ")
  );

  const matches = [];
  let hasAliasHit = false;

  for (const dj of djs || []) {
    const aliases = dj.aliases || [];
    const hit = aliases.some((a) => allText.includes(lower(a)));
    if (hit) {
      matches.push(dj);
      hasAliasHit = true;
    }
  }

  const mentionsDJWord = /\bdj\b|set|line[- ]?up|lineup|prodüktör|producer/i.test(
    userText || ""
  );

  let used;
  if (hasAliasHit) {
    used = matches;
  } else if (mentionsDJWord) {
    // Tüm DJ'leri yükleme, yönlendirme ver
    return ">>> Sistem Notu: Kullanıcı DJ'ler veya lineup hakkında genel bir soru sordu. Tüm listeyi dökmek yerine, 'Kimi soruyorsun?' tarzı cool bir yanıt ver.";
  } else {
    used = [];
  }

  if (!used.length) return "";

  const lines = used.map((dj) => {
    const header = `- ${dj.displayName || dj.id} (${joiner(dj.styles) || "stil bilinmiyor"}):`;
    const oneLine = dj.oneLine ? ` ${dj.oneLine}` : "";
    const bio = dj.bio ? ` ${dj.bio}` : "";
    const how = dj.howToTalk ? ` Konuşma notu: ${dj.howToTalk}` : "";
    return `${header}${oneLine}${bio}${how}`;
  });

  return [
    ">>> DJ / prodüktörler hakkında ek bağlam:",
    ...lines,
  ].join("\n");
}

function buildKnowledgeContext(userText, memory) {
  const blocks = [];

  const fBlock = pickFriendsContext(userText, memory);
  if (fBlock) blocks.push(fBlock);

  const cBlock = pickVenuesContext(userText, memory);
  if (cBlock) blocks.push(cBlock);

  const dBlock = pickDJsContext(userText, memory);
  if (dBlock) blocks.push(dBlock);

  return blocks.join("\n\n");
}

// Sistem promptunu tek yerden derleyen yardımcı (kişisel bellek + stil + kimlik)
function buildSystemPrompt(extraKnowledgeText = "") {
  const p = personality || {};
  const rules = p.style_rules || {};
  const owner = p.context?.owner || {};

  const interests = joiner(owner.interests);
  const hobbies = joiner(owner.hobbies);
  const music = joiner(owner.music_taste);
  const notes = owner.notes || "";

  // Arkadaşlar hem array hem de obje olabilir; ikisini de destekle (eski şema desteği)
  let friendLines = "";
  const f = owner.friends;
  if (Array.isArray(f)) {
    friendLines = f.map((name) => `- ${name}`).join("\n");
  } else if (f && typeof f === "object") {
    friendLines = Object.entries(f)
      .map(([name, info]) => {
        const parts = [];
        if (info?.personality) parts.push(info.personality);
        if (info?.ai_perception) parts.push(`Algım: ${info.ai_perception}`);
        if (info?.notes) parts.push(info.notes);
        return `- ${name}: ${parts.join(" ")}`.trim();
      })
      .join("\n");
  }

  const styleOpenings = Array.isArray(rules.openings)
    ? rules.openings.join(" / ")
    : "Bro / Dostum";
  const styleDo = Array.isArray(rules.do)
    ? rules.do.join("; ")
    : (rules.do || "");
  const styleDont = Array.isArray(rules.dont)
    ? rules.dont.join("; ")
    : (rules.dont || "");
  const styleTone = rules.tone || "samimi ve net";

  const base = [
    `Şu anki tarih ve saat: ${new Date().toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" })}.`,
    `Sen ${p.name}. Sahibin: ${p.owner}.`,
    `Özelliklerin: ${Array.isArray(p.traits) ? p.traits.join("; ") : (p.traits || "")
    }.`,
    `Stil:`,
    `- Açılış: ${styleOpenings} ile başla.`,
    `- Ton: ${styleTone}.`,
    styleDo ? `- Yap: ${styleDo}.` : "",
    styleDont ? `- Yapma: ${styleDont}.` : "",
    `=== KİŞİSEL BELLEK (KULLANICI SAĞLADI) ===`,
    owner.name ? `Sahip: ${owner.name}` : "",
    interests ? `İlgi alanları: ${interests}` : "",
    hobbies ? `Hobiler: ${hobbies}` : "",
    music ? `Müzik: ${music}` : "",
    notes ? `Notlar: ${notes}` : "",
    friendLines ? `Önemli kişiler (özet):\n${friendLines}` : "",
    `Talimat: Liste dışındaki gerçek kişiler hakkında uydurma yapma; bilmiyorsan "elimde veri yok" de.`,
    `Her zaman Türkçe yanıt ver.`
  ].filter(Boolean);

  if (extraKnowledgeText && extraKnowledgeText.trim().length > 0) {
    base.push(
      `=== DİNAMİK BAĞLAM (ARKADAŞLAR / MEKANLAR / DJ'LER) ===`,
      extraKnowledgeText.trim()
    );
  }

  return base.join("\n");
}



export async function askAI(userText, memory = [], mode = "maykutogpt") {
  const examples = personality.style_examples || [];

  let systemPrompt;
  let fewshot = [];

  if (mode === "tars") {
    // TARS MODU: tarsData.js'den dinamik promptu çek
    systemPrompt = getTarsSystemPrompt();
    console.log("🟦 Mode: TARS Activated");
  } else {
    // MAYKUTOGPT MODU (Varsayılan)
    const extraKnowledge = buildKnowledgeContext(userText, memory);
    systemPrompt = buildSystemPrompt(extraKnowledge);

    // Sadece Maykuto modunda few-shot örnekleri kullan
    fewshot = examples.flatMap((ex) => [
      { role: "user", content: ex.user },
      { role: "assistant", content: ex.assistant },
    ]);
  }

  const messages = [
    { role: "system", content: systemPrompt },
    ...fewshot,
    ...memory.map((m) => ({
      role: m.sender === "user" ? "user" : "assistant",
      content: m.text,
    })),
    { role: "user", content: userText },
  ];

  const payload = {
    // Modeli göndermiyoruz: server.js en uygun modeli seçiyor
    temperature: mode === "tars" ? 0.7 : 0.8, // TARS biraz daha stabil olsun
    top_p: 0.9,
    max_tokens: 2048,
    messages,
    mode, // Send mode to server for logging separation
  };

  // API_BASE boş string çünkü proxy kullanıyoruz
  const url = `${API_BASE}/api/chat`;
  console.log("➡️ POST", url, "| Mode:", mode);

  try {
    const { data } = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json" },
    });

    const text =
      data?.choices?.[0]?.message?.content ??
      data?.choices?.[0]?.text ??
      "";

    // Temizle
    let cleanText = sanitize(text);

    // Sadece Maykuto modunda "açılış" zorunluluğu var (Bro/Dostum)
    // ARTIK YOK - Sophisticated mode için bu zorlamayı kaldırıyoruz.
    // if (mode !== "tars") {
    //   cleanText = withOpening(cleanText);
    // }

    return cleanText || "Boş yanıt döndü.";
  } catch (err) {
    const status = err?.response?.status;
    const body = err?.response?.data;
    console.error("🟥 API Hatası:", {
      url,
      status,
      data: body,
      message: err.message,
    });
    throw new Error(`API error ${status ?? ""}: ${body?.error ?? err.message}`);
  }
}

export default askAI;
